/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

export const CORRECTIVE_ACTION_STATE = {
    FIXED: 'FIXED',
    NOT_FIXED: 'NOT_FIXED',
    NOT_PERFORMED: 'NOT_PERFORMED',
}

export const FAULT_STATES = {
    NEW: 'NEW',
    IN_PROGRESS: 'IN_PROGRESS',
    VERIFICATION: 'VERIFICATION',
    ON_HOLD: 'ON_HOLD',
    CLOSED_RESOLVED: 'CLOSED_RESOLVED',
    DELETED: 'DELETED',
    NEW_ALERT: 'NEW_ALERT',
    CLOSED_DUE_TO_LDI_IMPORT: 'CLOSED_DUE_TO_LDI_IMPORT',
    CLOSED_DUE_TO_INACTIVITY: 'CLOSED_DUE_TO_INACTIVITY',
}

export const CURRENT_FAULT_STATES = [FAULT_STATES.NEW, FAULT_STATES.IN_PROGRESS, FAULT_STATES.ON_HOLD, FAULT_STATES.VERIFICATION, FAULT_STATES.NEW_ALERT]

export const FAULT_COLORS = {
    NEW: '#F0142F',
    IN_PROGRESS: '#2293E0',
    VERIFICATION: '#4EA495',
    ON_HOLD: '#BABABA',
    CLOSED_RESOLVED: '#7AB548',
    DELETED: '#707070',
    NEW_ALERT: '#FFA500',
    CLOSED_DUE_TO_LDI_IMPORT: '#7A8200',
    CLOSED_DUE_TO_INACTIVITY: '#7A8200',
}

export const isClosedState = function(state) {
    return state === FAULT_STATES.CLOSED_RESOLVED || state === FAULT_STATES.CLOSED_DUE_TO_LDI_IMPORT || state === FAULT_STATES.CLOSED_DUE_TO_INACTIVITY
}

export const FAULT_ACTIONS = {
    START: 'startprogress',
    PUT_ON_HOLD: 'putonhold',
    CLOSE: 'close',
    DELETE: 'delete',
    ASSIGN: 'assign',
}

export const FAULT_SORT = {
    NAME: 'NAME',
    CREATED: 'CREATED',
    MODIFIED: 'MODIFIED',
}

export const FAULT_HISTORY_SORT = {
    HISTORY_CLOSED: 'MODIFIED',
    NAME: 'NAME',
}

export const SYMPTOM_STATES = {
    PRESENT: 'PRESENT',
    UNKNOWN: 'UNKNOWN',
    ABSENT: 'ABSENT',
    LATCHED: 'LATCHED',
}

export const SYMPTOM_TYPES = {
    REPORTED_SYMPTOM: 'REPORTED_SYMPTOM',
    OBSERVATIONS_TYPE: 'OBSERVATION',
    HEALTH_INDICATOR_TYPE: 'HEALTH_INDICATOR',
}

export const LOG_OBJECT_TYPES = {
    FAULT_CONDITION: 'FAULT_CONDITION',
}

export const LOG_ACTION_TYPES = {
    STATE_CHANGED: 'STATE_SET',
    VALUE_SET: 'VALUE_SET',
    VALUE_SET_INTERNAL: 'VALUE_SET_INTERNAL',
    VALUE_SET_LEARNING_LOOP: 'VALUE_SET_LEARNING_LOOP',
    REPORTED: 'VALUE_REPORTED',
    LL_PACKET_SENT: 'LL_PACKET_SENT',
    ASSIGNEE_SET: 'ASSIGNEE_SET',
    LDI_IMPORT: 'LDI_IMPORT',
}

export const ACTION_TYPES = {
    TEST: 'TEST',
    CORRECTIVE_ACTION: 'CORRECTIVE_ACTION',
}
export const ACCESS = {
    READ: 'READ',
    WRITE: 'WRITE',
    NONE: 'NONE',
}